import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll2(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("vbIncomingDocInBookView", {params: params});
  },

  findAllForConfigLD(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("vbIncomingDocInBookView/forConfigLD", {params: params});
  },

  countAllForConfigLD(form) {
    return httpService.get("vbIncomingDocInBookView/count", {params: form});
  },

  findAll(usingAdvanceSearch, keyword, bookId, form, pageable, fromDocDate, toDocDate) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      utils.merge(
        {
          usingAdvanceSearch: usingAdvanceSearch,
          keyword: keyword,
          bookId: bookId,
          fromDocDate: fromDocDate,
          toDocDate: toDocDate
        },
        form
      ),
      pageable
    );

    return httpService.get("vbIncomingDocInBookView", {params: params});
  },

  count(usingAdvanceSearch, keyword, bookId, form, fromDocDate, toDocDate) {
    let params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        bookId: bookId,
        fromDocDate: fromDocDate,
        toDocDate: toDocDate
      },
      form
    );

    return httpService.get("vbIncomingDocInBookView/count", {params: params});
  },

  findAllByVbDocInBookBookIdAndIncomingDate(bookId, incomingDate) {
    return httpService.get("vbIncomingDocInBookView/findAllByVbDocInBookBookIdAndIncomingDate",
      {params: {bookId: bookId, incomingDate: incomingDate}});
  },

  findAllByVbDocInBookBookIdAndLessThanIncomingDate(bookId, incomingDate) {
    return httpService.get("vbIncomingDocInBookView/findAllByVbDocInBookBookIdAndLessThanIncomingDate",
      {params: {bookId: bookId, incomingDate: incomingDate}});
  },

  findFirstByVbDocInBookBookIdAndLessThanIncomingDate(bookId, incomingDate) {
    return httpService.get("vbIncomingDocInBookView/findFirstByVbDocInBookBookIdAndLessThanIncomingDate",
      {params: {bookId: bookId, incomingDate: incomingDate}});
  },

  findMaxSubBookNumberByBookIdAndBookNumber(bookId, bookNumber) {
    return httpService.get("vbIncomingDocInBookView/findMaxSubBookNumberByBookIdAndBookNumber",
      {params: {bookId: bookId, bookNumber: bookNumber}});
  },

  findAllByBlockedRole(form, pageable, userDeptRoleId) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      {
        userDeptRoleId: userDeptRoleId
      },
      form
    );
    params = utils.merge(params, pageable);
    return httpService.get("/vbIncomingDocInBookView/findAllByBlockedRole", {
      params: params
    });
  },

  findAllForConfigLDV2(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("vbIncomingDocInBookV2View/forConfigLD", {params: params});
  },

  countAllForConfigLDV2(form) {
    return httpService.get("vbIncomingDocInBookV2View/count", {params: form});
  },
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingDocInBookViewService.js